export default "__VITE_ASSET__e70098d2__"